import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Mock data para The Keeper Lab Landing Page

export const mockData = {
  hero: {
    title: "THE KEEPER LAB",
    subtitle: "Donde se construyen los guardianes del arco.",
    description: "La primera agencia especializada exclusivamente en porteros.",
    tagline1: "Fundada por un arquero.",
    tagline2: "Inspirada en la experiencia de la élite mundial.",
    tagline3: "No representamos posiciones.",
    tagline4: "Representamos mentalidades.",
    ctaText: "Solicitar evaluación privada"
  },
  
  keepers: [
    {
      id: 1,
      name: "Christiane Endler",
      club: "Olympique Lyonnais",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/qqioml0s_IMG_7423.jpeg",
      achievement: "Champions League Winner"
    },
    {
      id: 2,
      name: "Emily Burns",
      club: "Nantes",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/hsk5kxck_IMG_9990.jpeg",
      achievement: "International Goalkeeper"
    },
    {
      id: 3,
      name: "Nayluisa Cáceres",
      club: "Tenerife",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/fpiaizz1_IMG_9991.jpeg",
      achievement: "Professional Goalkeeper"
    },
    {
      id: 4,
      name: "Antonia Canales",
      club: "Badalona Women",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/t1r0s30i_IMG_9985.jpeg",
      achievement: "Rising Talent"
    },
    {
      id: 5,
      name: "Christian Bravo",
      club: "Huachipato",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/ch1955bo_IMG_9983.jpeg",
      achievement: "Chilean National Team"
    },
    {
      id: 6,
      name: "José Sánchez",
      club: "Atlético de Madrid",
      image: "https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/hhpe7ob6_IMG_9982.jpeg",
      achievement: "Youth Elite Development"
    }
  ],
  
  services: [
    {
      icon: "target",
      title: "Plan de carrera estratégico personalizado",
      description: "Diseñamos tu trayectoria profesional con visión internacional"
    },
    {
      icon: "globe",
      title: "Representación internacional",
      description: "Red directa con clubes y entrenadores especializados en arqueros"
    },
    {
      icon: "brain",
      title: "Desarrollo mental específico",
      description: "Fortalecimiento psicológico diseñado para la presión del arco"
    },
    {
      icon: "file-text",
      title: "Gestión contractual de alto nivel",
      description: "Negociaciones profesionales que protegen tus intereses"
    },
    {
      icon: "trending-up",
      title: "Posicionamiento de marca personal",
      description: "Construcción estratégica de tu identidad como profesional élite"
    },
    {
      icon: "users",
      title: "Red especializada",
      description: "Conexión directa con el ecosistema exclusivo de porteros"
    }
  ],
  
  stats: [
    { number: "6", label: "Porteros de élite representados" },
    { number: "1", label: "Champions League ganada" },
    { number: "100%", label: "Especialización en arqueros" },
    { number: "∞", label: "Compromiso con la excelencia" }
  ]
};

export const submitEvaluation = async (formData) => {
  try {
    const response = await axios.post(`${API}/evaluations`, formData);
    return response.data;
  } catch (error) {
    console.error("Error submitting evaluation:", error);
    throw error;
  }
};
